import { useEffect } from 'react';
import { LendingLimitApi } from '@apply/api';
import { applicationInsights } from '../../../../../ApplicationInsights';
import { IBorrowers } from '@apply/api/src/api/LendingLimitApi';
import { useState } from 'react';
import { DropDownBox, DropDownBoxSearchMode } from '@apply/components';

interface GuarantorDropDownSearchProps {
    onGurantorLendingLimitsSearch: (id: number | undefined) => void;
}

export const GuarantorDropDownSearch: React.FC<GuarantorDropDownSearchProps> = ({ onGurantorLendingLimitsSearch }) => {
    const lendingLimitApi = new LendingLimitApi.LendingLimitApi(applicationInsights);
    const [id, set_id] = useState(undefined);
    const [lendingLimitBorrowers, set_LendingLimitBorrowers] = useState<IBorrowers[]>([]);

    const _loadLendingLimitBorrowers = async () => {
        const data = await lendingLimitApi.getPrincipals();
        set_LendingLimitBorrowers(data.result);
    };

    useEffect(() => {
        _loadLendingLimitBorrowers();
    }, []);

    return (
        <>
            <div className='lending-limits-criteria-search'>
                <DropDownBox
                    id='guarantorDropDown'
                    value={id}
                    onChange={(value) => set_id(value)}
                    required={true}
                    width='400px'
                    displayExpr='name'
                    valueExpr='id'
                    dataSource={lendingLimitBorrowers}
                    searchEnabled={true}
                    searchMode={DropDownBoxSearchMode.Contains}
                />
                <div className='lending-limits-criteria-search-button'>
                    <button
                        type='button'
                        className='button primary'
                        data-dismiss='modal'
                        onClick={() => onGurantorLendingLimitsSearch(id)}
                        style={{ height: '40px' }}
                    >
                        Search
                    </button>
                </div>
            </div>
        </>
    );
};
